"use client";

import React from "react";
import { ThreeUIParticleWordmark } from "@/components/threeui/dynamic-effects";
import { LazyEffect } from "@/components/threeui/lazy-effect";

/**
 * Final brand signature after the footer (§24). The real ThreeUI Particle
 * Wordmark reading "QUTO AI" (§22), monochrome (§23), default visual (§21).
 *
 * The section spans the FULL viewport width — no Container / max-width wrapper
 * (§15, §16). The wordmark box is aspect-locked to the effect's own 1600×300
 * artwork (16/3), so at any width it fills edge-to-edge AND is never clipped
 * (§17, §18). The artwork was re-cut (patch-threeui.js) so "QUTO AI" fills
 * ~94% of the width and ~92% of the height — the box hugs the wordmark with no
 * empty bands. This aspect MUST match the patched SVG (16/3) or the contain-fit
 * would pillar/letterbox; and NO max-height is set, because clamping height on a
 * full-width box would distort that aspect and bring the bands back. Gated +
 * given a static reduced-motion fallback.
 */
export function FooterParticleWordmark() {
  return (
    <section
      aria-label="Quto AI"
      className="relative w-full overflow-hidden border-t border-neutral-900 bg-[#020202] select-none"
    >
      <div aria-hidden="true" className="relative w-full aspect-[16/3]">
        <LazyEffect
          className="absolute inset-0 size-full"
          disableOnMobile={false}
          fallback={<StaticWordmark />}
        >
          <ThreeUIParticleWordmark />
        </LazyEffect>
      </div>
    </section>
  );
}

/** Static, animation-free wordmark for reduced-motion (and pre-mount) states. */
function StaticWordmark() {
  return (
    <div className="flex size-full items-center justify-center">
      <span className="font-display text-[clamp(2rem,12vw,7rem)] font-black tracking-tight text-white">
        QUTO AI
      </span>
    </div>
  );
}
